import { render, staticRenderFns } from "./InstitutionEntry.vue?vue&type=template&id=1947ec1f&scoped=true"
import script from "./InstitutionEntry.vue?vue&type=script&lang=js"
export * from "./InstitutionEntry.vue?vue&type=script&lang=js"
import style0 from "./InstitutionEntry.vue?vue&type=style&index=0&id=1947ec1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947ec1f",
  null
  
)

export default component.exports